module.exports = {};


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/~/core-js/modules/_iterators.js
// module id = ../../../../core-js/modules/_iterators.js
// module chunks = 0